export const limitString = (string, length) => {
  return string.substring(0, length) + (string.length > length ? "..." : "");
};
